/**
 * IMPORTS
 */

import {
  ILiberarRemessaPayload,
  ILiberarRemessasLotePayload,
  IRecepcaoLiberarRemessaClientePayload,
} from "@/hooks/liberar-remessa/index.d";

import { liberarRemessaRepository } from "@/repositories/liberar-remessa";

/**
 * Função que busca as remessas liberadas para o balcao 🛠️.
 */
const handleGetRemessasLiberadasBalcao = async (
  accessToken: string,
  currentPage: number,
  itemsPerPage: number,
  searchItem: string
) => {
  try {
    const data = await liberarRemessaRepository.buscarRemessasLiberadasBalcao(
      accessToken,
      currentPage,
      itemsPerPage,
      searchItem
    );

    return data;
  } catch (error: any) {
    console.log("ERROR AO BUSCAR REMESSAS LIBERADAS BALCAO: ", error);

    return error;
  }
};

/**
 * Função que faz a liberação de uma remessa para o balcao 🛠️.
 */
const handleLiberarRemessa = async (accessToken: string, payload: ILiberarRemessaPayload) => {
  try {
    const data = await liberarRemessaRepository.liberarRemessa(accessToken, payload);

    return data;
  } catch (error) {
    return error as any;
  }
};

/**
 * Função que faz a liberação de uma remessa para o cliente 🛠️.
 */
const handleRecepcaoLiberarRemessaCliente = async (
  accessToken: string,
  payload: IRecepcaoLiberarRemessaClientePayload
) => {
  try {
    const data = await liberarRemessaRepository.recepcaoLiberarRemessaParaCliente(
      accessToken,
      payload
    );

    return data;
  } catch (error) {
    return error as any;
  }
};

const handleLiberarRemessasEmLote = async (
  accessToken: string,
  payload: ILiberarRemessasLotePayload
) => {
  return liberarRemessaRepository.liberarRemessasEmLote(accessToken, payload);
};

const handleRecepcaoLiberarRemessasEmLote = async (
  accessToken: string,
  payload: ILiberarRemessasLotePayload
) => {
  return liberarRemessaRepository.recepcaoLiberarRemessasEmLote(accessToken, payload);
};

/**
 * EXPORTS
 */
export {
  handleGetRemessasLiberadasBalcao,
  handleLiberarRemessa,
  handleLiberarRemessasEmLote,
  handleRecepcaoLiberarRemessaCliente,
  handleRecepcaoLiberarRemessasEmLote,
};
